export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f045295266653404a308bb9cc1a12571cb2a74a46&name=fetchTypeahead!'